export const initialState = {
  fromdb: null,
  tablePagesFromdb: 0,
  depositsTPVForDownload: null,
  depositDetails: null,
  successModal: {
    show: false,
    message: null,
  },
  errorModal: {
    show: false,
    message: null,
  },
  isLoading: false,
  error: null,
};
